// In dev, use /api so Vite proxies to admin.3afer.net and avoids CORS. In prod, use full API URL.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || (import.meta.env.DEV ? '' : 'https://admin.3afer.net') + '/api'
export const STORAGE_URL = import.meta.env.VITE_STORAGE_URL || 'https://3afer.net'

export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  USER: 'user',
  LOCALE: 'locale',
}

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  COURSES: '/courses',
  COURSE_DETAIL: '/courses/:id',
  LECTURE: '/courses/:courseId/lectures/:lectureId',
  PROFILE: '/profile',
  MY_COURSES: '/my-courses',
  NOTES: '/notes',
  EXAMS: '/exams',
  SUBSCRIPTIONS: '/subscriptions',
  PAYMENTS: '/payments',
  COMMUNITY: '/community',
  REELS: '/reels',
  NOTIFICATIONS: '/notifications',
  SEARCH: '/search',
  CHAT: '/chat',
}

export const COLORS = {
  PRIMARY: '#2473B4',
  SECONDARY: '#EAA64D',
  BACKGROUND: '#FFFFFF',
  FOREGROUND: '#252525',
  CARD: '#FFFFFF',
  MUTED: '#ECECF0',
  MUTED_FOREGROUND: '#717182',
  BORDER: 'rgba(0, 0, 0, 0.1)',
  SUCCESS: '#10B981',
  ERROR: '#D4183D',
  WARNING: '#EAA64D',
}

export const BREAKPOINTS = {
  SM: '640px',
  MD: '768px',
  LG: '1024px',
  XL: '1280px',
  '2XL': '1536px',
}

/**
 * Get the full URL for a storage file
 * If the path is already a full URL, return it as is
 * If it's a relative path, prepend the storage URL
 * @param {string} path - The file path (relative or absolute URL)
 * @returns {string} - The full URL, or empty string if path is invalid
 */
export const getStorageUrl = (path) => {
  // Return empty string for null, undefined, or empty paths
  if (!path || typeof path !== 'string' || !path.trim()) {
    return ''
  }
  
  const trimmedPath = path.trim()
  
  // If already a full URL, handle it
  if (trimmedPath.startsWith('http://') || trimmedPath.startsWith('https://')) {
    // External CDN URLs (Bunny, Vimeo, etc.) - return as is, don't modify
    const lowerPath = trimmedPath.toLowerCase()
    if (lowerPath.includes('b-cdn.net') || 
        lowerPath.includes('mediadelivery.net') || 
        lowerPath.includes('bunnycdn') ||
        lowerPath.includes('vimeo') ||
        lowerPath.includes('.m3u8')) {
      return trimmedPath
    }
    // If 'storage' already exists in the url, return as is
    if (trimmedPath.includes('/storage/')) {
      return trimmedPath
    }
    // If not, add '/storage' after domain (only for our own storage URLs)
    try {
      const url = new URL(trimmedPath)
      // Only add '/storage' if not present and it's our domain
      if (!url.pathname.startsWith('/storage/')) {
        url.pathname = `/storage${url.pathname.startsWith('/') ? '' : '/'}${url.pathname}`
      }
      return url.toString()
    } catch {
      // If URL parsing fails, return original path
      return trimmedPath
    }
  }
  
  // Remove leading slash if present to avoid double slashes
  const cleanPath = trimmedPath.startsWith('/') ? trimmedPath.slice(1) : trimmedPath
  // Skip if path is empty after cleaning
  if (!cleanPath) {
    return ''
  }
  // Add '/storage/' if not present
  const storagePath = cleanPath.startsWith('storage/') ? cleanPath : `storage/${cleanPath}`
  return `${STORAGE_URL}/${storagePath}`
}

